import React,{useEffect, useState} from 'react';
import { Routes, Route, Outlet } from "react-router-dom";
import UserPermission from "../UserPermission/UserPermission";
import Dashboard from "../Dashboard/Dashboard";
import { useDispatch, useSelector } from 'react-redux';
import './Home.css';

import { msalInstance } from '../../index';
import  config  from '../../env.json';
import axios from 'axios';
import { getAuthApi, getEmpPermissions } from '../../apis/authApi/authApi';
import { setUserVirtualNumber,setUserDetails } from '../../app/slice/authApiSlice';
import { setLoginDetails } from '../../app/slice/loginSlice';
import { setUserPermissions } from '../../app/slice/userPermisssionSlice';

function Home() {
  const IsUserPermissionConfigured=useSelector((state:any)=>state.userPermisssion.IsUserPermissionConfigured);

  const dispatch = useDispatch();

  useEffect(()=>{
    msalInstance.handleRedirectPromise().then((e: any) => {
      console.log("REACT_APP_AUTH_API_BASE", config.REACT_APP_AUTH_API_BASE)
  
  
      if(e){
        
        axios.defaults.headers.common["Authorization"] = "Bearer "+e.accessToken;
        dispatch(setLoginDetails({'token':e.accessToken,'userName':e.account.username,'userAccount':e}));
        getAuthApi({authToken:"Bearer "+ e.accessToken},(res:any)=>{
          
          if(res){
            dispatch(setUserVirtualNumber(
              {
                EmployeeV_Nbr: res[0].EmployeeV_Nbr,
                Id: res[0].Id
              }
            ));
            dispatch(setUserDetails(
              {
                EmployeeEmail_Adr:res[0].EmployeeEmail_Adr,
                EmployeePh_Nbr:res[0].EmployeePh_Nbr,
                EmployeeQR_Cd:res[0].EmployeeQR_Cd,
                EmployeeFull_Nm:res[0].EmployeeFull_Nm
              }
            ));
            
            getEmpPermissions((res:any)=>{
              dispatch(setUserPermissions(res));
            })
          }   
        });
  
        sessionStorage.setItem("login",e.accessToken);
        sessionStorage.setItem('loginName',e.account.username);
      }});
  },[])


  return (

    <div id="main">
      <Dashboard/>
    </div>
          
  );
}

export default Home;
